export enum EnumApartment {
  Flat = 'Flat',
  House = 'House',
  Land = 'Land',
  Commerce = 'Commerce',
}
